import React from 'react';
import { Table } from 'reactstrap';
import parse from 'html-react-parser';
import { EnergyConsumption } from '../../../../../../../services/types/Calculator';
import NumberFormatterSinSeparador from '../../../NumberFormatterSinSeparador';

interface Props {
  energyConsumption: EnergyConsumption;
}

const EnergyConsumptionDetails: React.FC<Props> = ({ energyConsumption }) => {
  const totalCo2e = energyConsumption.rows.reduce((sum, row) => sum + row.co2Emission, 0);
  let totalCarbonSum = energyConsumption.rows.reduce((sum, row) => sum + row.totalEmission, 0);
  totalCarbonSum -= totalCo2e;

  const formatUnitWithSubscript = (unitString: string | null | undefined) => {
    if (!unitString) {
      return '';
    }
    let formatted = unitString.replace(/CO2e/g, 'CO<sub>2</sub>e');
    formatted = formatted.replace(/CO2/g, 'CO<sub>2</sub>');
    return formatted;
  };

  return (
    energyConsumption.rows &&
    energyConsumption.rows.length > 0 && (
      <>
        <h5>
          Enter Data for the Annual Electricity and Fuel Consumption for the Construction Phase of
          the Project
        </h5>
        <div className="table-wrapper">
          <Table
            responsive
            className="table--bordered calculator table-details"
            style={{ tableLayout: 'fixed' }}
          >
            <>
              <colgroup>
                <col style={{ width: '16%' }} />
                <col style={{ width: '9%' }} />
                <col style={{ width: '12%' }} />
                <col style={{ width: '17%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '18%' }} />
                <col style={{ width: '16%' }} />
              </colgroup>
              <thead>
                <tr>
                  <th>Energy Type</th>
                  <th>Units</th>
                  <th>Quantity Used</th>
                  <th>Default Heating Value</th>
                  <th>Units</th>
                  <th>Default Emissions Factor</th>
                  <th>Units</th>
                </tr>
              </thead>
              <tbody>
                {energyConsumption.rows.map((row) => (
                  <tr key={row.id}>
                    <td>{row.energyType}</td>
                    <td>{row.energyUnit}</td>
                    <td>
                      <NumberFormatterSinSeparador value={row.value} />
                    </td>

                    <td>
                      {row.heatingValue !== null || row.heatingValue ? (
                        <NumberFormatterSinSeparador value={row.heatingValue} />
                      ) : (
                        'N/A'
                      )}
                    </td>
                    <td>{row.heatingUnit}</td>
                    <td>
                      <NumberFormatterSinSeparador value={row.emissionFactor} />
                    </td>
                    <td>{parse(formatUnitWithSubscript(row.emissionUnit))}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="subtotal-column" colSpan={7}>
                    Subtotal: <NumberFormatterSinSeparador value={totalCarbonSum} /> t CO
                    <sub>2</sub>
                  </td>
                </tr>
              </tfoot>
            </>
          </Table>
        </div>
        <br />
        <h5>Enter Data for CH4 and N2O Emissions</h5>
        <div className="table-wrapper">
          <Table
            responsive
            className="table--bordered calculator table-details"
            style={{ tableLayout: 'fixed' }}
          >
            <>
              <colgroup>
                <col style={{ width: '16%' }} />
                <col style={{ width: '9%' }} />
                <col style={{ width: '12%' }} />
                <col style={{ width: '17%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '18%' }} />
                <col style={{ width: '16%' }} />
              </colgroup>
              <thead>
                <tr>
                  <th>Energy Type</th>
                  <th>Units</th>
                  <th>Quantity Used</th>
                  <th>Default Emissions Factor</th>
                  <th>Units</th>
                  <th>Default Emissions Factor</th>
                  <th>Units</th>
                </tr>
              </thead>
              <tbody>
                {energyConsumption.rows.map((row) => (
                  <tr key={row.id}>
                    <td>{row.energyType}</td>
                    <td>{row.ch4FactorUnit}</td>
                    <td>
                      <NumberFormatterSinSeparador value={row.ch4Value} />
                    </td>
                    <td>
                      <NumberFormatterSinSeparador value={row.ch4Factor} />
                    </td>
                    <td>{row.ch4FactorUnit}</td>
                    <td>
                      <NumberFormatterSinSeparador value={row.n2OFactor} />
                    </td>
                    <td>{row.n2OFactorUnit}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="subtotal-column" colSpan={7}>
                    Subtotal: <NumberFormatterSinSeparador value={totalCo2e} /> t CO<sub>2</sub>e
                  </td>
                </tr>
              </tfoot>
            </>
          </Table>
        </div>
      </>
    )
  );
};

export default EnergyConsumptionDetails;
